import { withInstall } from '@hd-front-end/utils'
import Segmented from './src/segmented.vue'

export const ElSegmented = withInstall(Segmented)
export default ElSegmented

export * from './src/segmented'
